import React, { useState } from 'react'

import { DROP_DOWN_APIS } from '../../Common/Constants';
import { useDispatch } from 'react-redux';
import { dataSliceAction } from '../../Redux/DataSlice/DataSlice';
import api from '../../http';
import { ErrorHandlingMessage } from '../../Utils/ErrorHandlingMessage';
import { resetTabs } from '../../Redux/TabsSlice/TabsSlice';
import { RefreshCw } from 'lucide-react';
const Refresh = () => {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const handleRefresh = async () => {
        try {
            setLoading(true)
            const promises = DROP_DOWN_APIS.flatMap(apiType => apiType.apis.map(mainApi => api.get(`${apiType.type}/api${mainApi}`)));
            const responses = await Promise.allSettled(promises);
            let keysAndData = {};
            responses.forEach(response => {
                if (response.status === 'fulfilled') {
                    let apiUrl = response.value.config.url;
                    let keyName = apiUrl.slice(apiUrl.lastIndexOf('/') + 1);
                    let data = response.value.data.dataModel;
                    keysAndData[keyName] = data
                }

            });
            dispatch(dataSliceAction(keysAndData))
            // dispatch(activeMainTab({
            //     name: 'dashboard',
            //     key: 1,
            //     title: 'Dashboard',
            // }));
            dispatch(resetTabs())

        } catch (error) {
            ErrorHandlingMessage(error)
        }
        finally {
            setLoading(false)
        }
    }
    return (
        <button
            type="button"
            onClick={handleRefresh}
            aria-label="Refresh data"
            disabled={loading}
            className="inline-flex h-8 w-8 items-center justify-center rounded-md text-[#889AB3] outline-none transition-colors duration-150 hover:bg-[#F3F4F7] hover:text-[#404D60]"
        >
            <RefreshCw size={16} strokeWidth={1.7} className={loading ? "animate-spin" : ""} />
        </button>
    )
}

export default Refresh